import { useLocation } from 'react-router-dom';
import { useGlobalStateSelector, words } from './globalState';
import { handleClickGetDuelHistoryAll } from 'duelHistory';
import {
  handleClickGoBack,
  handleClickPurchaseItem,
  handleClickDuelHistory,
  handleClickCardList,
} from './monadomCore';
import iconReplay from './live_tv_FILL0_wght400_GRAD0_opsz24.svg';
import iconShare from './share_FILL0_wght400_GRAD0_opsz48.svg';
import imageMagicRed from './magicRed.png';
import imageEmilicaBT from './emilicaBT.png';
import imageHalcionBT from './halcionBT.png';
import imageSayokoBT from './sayokoBT.png';
import imageNarumiyakunBT from './narumiyakunBT.png';
import imageOmennoshoujoBT from './omennoshoujoBT.png';
import imageDensetsunoshoujoBT from './densetsunoshoujoBT.png';
import imageAnkokunomaouLuciferBT from './ankokunomaouLuciferBT.png';
import imageNzorichterBT from './nzorichterBT.png';
import imageKurumichanBT from './kurumichanBT.png';
import imageToshinousanBT from './toshinousanBT.png';
import imageCardDetailHarukaMizugiVersion from './cardDetailHarukaMizugiVersion.png';
import imageMonatoka from './monatoka.png';

// ABOUT KNIGHTS OF MONADOM
function AboutKnightsOfMonadom() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const location = useLocation();

  // const duelHistoryExample = [
  //   {
  //     roomId: 'MUBqe6g86L3X8cgjstAiEKFPdFdS6RDcnB',
  //     duelNo: 651,
  //     round: 2,
  //   },
  //   {
  //     roomId: 'M9x3hWi8FTvQ5osmxShvDqUukDRX2WfLZH',
  //     duelNo: 1,
  //     round: 2,
  //   },
  //   {
  //     roomId: 'MUBqe6g86L3X8cgjstAiEKFPdFdS6RDcnB',
  //     duelNo: 647,
  //     round: 2,
  //   },
  // ];

  let duelHistoryExampleBlock;
  let creatorsCardExample;

  if (state.config.clientParameters.examples !== undefined) {
    const duelHistoryExample = state.config.clientParameters.examples.duelHistoryExample;

    const duelHistoryQueryParameter01 = `?roomid=${duelHistoryExample[0].roomId}&duelno=${duelHistoryExample[0].duelNo}&round=${duelHistoryExample[0].round}`;
    const duelHistoryQueryParameter02 = `?roomid=${duelHistoryExample[1].roomId}&duelno=${duelHistoryExample[1].duelNo}&round=${duelHistoryExample[1].round}`;
    const duelHistoryQueryParameter03 = `?roomid=${duelHistoryExample[2].roomId}&duelno=${duelHistoryExample[2].duelNo}&round=${duelHistoryExample[2].round}`;

    duelHistoryExampleBlock =
    <div className='flexRow justifyContentCenter alignItemsCenter '>
      <button className='button1'
        onClick={ () => {
          navigate(
            (process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelhistorydetail' : '/duelhistorydetail') + duelHistoryQueryParameter01,
            { state: { previousLocation: 'aboutknightsofmonadom' } }
          );
        }}
      >
        <img className='size2x2' src={iconReplay} alt='replay' />
      </button>
      <button className='button1'
        onClick={ () => {
          navigate(
            (process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelhistorydetail' : '/duelhistorydetail') + duelHistoryQueryParameter02,
            { state: { previousLocation: 'aboutknightsofmonadom' } }
          );
        }}
      >
        <img className='size2x2' src={iconReplay} alt='replay' />
      </button>
      <button className='button1'
        onClick={ () => {
          navigate(
            (process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelhistorydetail' : '/duelhistorydetail') + duelHistoryQueryParameter03,
            { state: { previousLocation: 'aboutknightsofmonadom' } }
          );
        }}
      >
        <img className='size2x2' src={iconReplay} alt='replay' />
      </button>
    </div>

    // const creatorsCardExample = {
    //   asset: 'A12153265217308668697',
    // };

    creatorsCardExample = state.config.clientParameters.examples.creatorsCardExample[0];
  }

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoBack(state, dispatch, navigate, location) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter' >
        { headerRelative }
        <div className='flexRow justifyContentCenter '>
          <div className='flexColumn justifyContentFlexStart alignItemsFlexEnd width48vw padding2'>
            <img className='cardImageAbout' src={imageEmilicaBT} alt='emilica' />
            <div className='cardImageAbout flexColumn justifyContentCenter alignItemsFlexStart '>
              <div className='font1p5 marginTopBottom1' >
                モナダム対応モナカードを集めてデッキを組もう。<br/>
                {/* モナトカポイントをチャージして準備完了。 */}
              </div>
              <button className='backgroundColorTransparent borderNone riseOut2 flexColumn justifyContentCenter alignItemsCenter cursor'
                onClick={ () => {
                  handleClickPurchaseItem(state, dispatch, navigate, { previousLocation: 'aboutknightsofmonadom' });
                }}
              >
                <div className='marginTopBottom1' >
                  モナダム対応モナカード、モナトカポイントはこちらで購入できます。
                </div>
              </button>
            </div>
            <img className='cardImageAbout' src={imageHalcionBT} alt='halcion' />
            <div className='cardImageAbout flexColumn justifyContentCenter alignItemsCenter '>
              <div className='font1p5 marginTopBottom1' >
                遊び方はカンタン。<br/>
                ナイトカードを1枚選択して召喚すれば、<br/>
                ナイトのプロフィールやフィールドの状況に沿ってAIがバトルを展開！
              </div>
            </div>
            <img className='cardImageAbout' src={imageOmennoshoujoBT} alt='omennoshoujo' />
            <div className='cardImageAbout flexColumn justifyContentCenter alignItemsCenter '>
              <div className='font1p5 marginTopBottom1' >
                バトルの様子を見てみよう！
              </div>
              { duelHistoryExampleBlock }
              <button className='backgroundColorTransparent borderNone riseOut2 flexColumn justifyContentCenter alignItemsCenter cursor'
                onClick={ () => {
                  handleClickGetDuelHistoryAll(state, dispatch, 0, { action: 'duelHistoryAll' });
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAll'});
                  handleClickDuelHistory(state, dispatch, navigate, { previousLocation: 'aboutknightsofmonadom' });
                }}
              >
                <div className='font1p5 marginTopBottom1' >
                  ここからもっとたくさんのバトルが見れるよ。
                </div>
              </button>
            </div>
            <img className='cardImageAbout' src={imageAnkokunomaouLuciferBT} alt='ankokunomaouLucifer' />
            <div className='cardImageAbout flexColumn justifyContentCenter alignItemsCenter '>
              <div className='font1p5 marginTopBottom1' >
                バトルストーリーを楽しむのは、モナダムの大きな醍醐味のひとつ。<br/>
                面白いストーリーができたら、みんなにシェアしよう！<br/>
                <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                  <div className=''>
                    (デュエル戦歴画面のシェアボタン
                  </div>
                    <img className='button1Dummy size2x2' src={iconShare} alt='share' />
                  <div className=''>
                    を押してね。)
                  </div>
                </div>
              </div>
            </div>
            <img className='cardImageAbout' src={imageKurumichanBT} alt='kurumichan' />
          </div>
          <div className='flexColumn justifyContentFlexStart alignItemsFlexStart width48vw padding2'>
            <div className='height15 flexColumn justifyContentCenter alignItemsCenter'>
              <div className='font2 marginTopBottom1' >
                Knights of Monadomとは<br/>
              </div>
              <div className='marginTopBottom1' >
                ※愛称、モナダム
              </div>
            </div>
            <img className='cardImageAbout' src={imageSayokoBT} alt='sayoko' />
            <div className='cardImageAbout flexColumn justifyContentCenter alignItemsCenter '>
              <div className='font1p5 marginTopBottom1' >
                対コンピュータ戦、対人戦を選んでデュエルを始めよう。
              </div>
            </div>
            <img className='cardImageAbout' src={imageNarumiyakunBT} alt='narumiyakun' />
            <div className='cardImageAbout flexColumn justifyContentCenter alignItemsCenter '>
              <div className='font1p5 marginTopBottom1' >
                魔法を使えば戦略の幅も広がります。
              </div>
              <div className='marginTopBottom1' >
                <img className='width10' src={imageMagicRed} alt='magic red' />
              </div>
            </div>
            <img className='cardImageAbout' src={imageDensetsunoshoujoBT} alt='densetsunoshoujo' />
            <div className='flexColumn justifyContentCenter alignItemsCenter '>
              <div className='font1p5 marginTopBottom1' >
                自分でモナダム対応カードをつくることもできます。<br/>
                {/* 発行、販売も自由！ */}
              </div>
              <button className='backgroundColorTransparent borderKOMFatBorder marginTopBottom1 riseOut2 cursor'
                onClick={ () => {
                  if (creatorsCardExample !== undefined && Object.keys(state.registeredCard).length >= 1) {
                    const body = {
                      card: {
                        asset: creatorsCardExample.asset, 
                      },
                    };

                    const popup = { type: 'monsterDetail', body: body };
                    dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
                  }
                }}
              >
                <img className='width50' src={imageCardDetailHarukaMizugiVersion} alt='cardDetailHarukaMizugiVersion' />
              </button>
            </div>
            <img className='cardImageAbout' src={imageNzorichterBT} alt='nzorichter' />
            <div className='cardImageAbout flexColumn justifyContentCenter alignItemsCenter '>
              <div className='font1p5 marginTopBottom1' >
                {`現在発行、登録されているカードは${300}種類以上！`}
              </div>
              <div className='marginTopBottom1' >
                ※公式オリジナルカード、公式レプリカカード、一般クリエイターカードすべて含みます。
              </div>
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
                onClick={ () => handleClickCardList(state, dispatch, navigate, { previousLocation: 'aboutknightsofmonadom' }) }
              >
                { words.cardList[state.language] }
              </button>
            </div>
            <img className='cardImageAbout' src={imageToshinousanBT} alt='toshinousan' />
          </div>
        </div>
        <div className='flexRow justifyContentCenter alignItemsCenter '>
          <img className='lpMainImage' src={imageMonatoka} alt='monatoka' />
          <div className='flexColumn margin1 ' >
            <div className='flexRow margin1'>
              <div className='width10'>
                会社名
              </div>
              <div className=''>
                株式会社モナトカ
              </div>
            </div>
            <div className='flexRow margin1'>
              <div className='width10'>
                代表取締役
              </div>
              <div className=''>
                渡邉潤平
              </div>
            </div>
            <div className='flexRow margin1'>
              <div className='width10'>
                所在地
              </div>
              <div className=''>
                〒101-0051 東京都千代田区神田神保町2-10-31 IWビル1F
              </div>
            </div>
            <div className='flexRow margin1'>
              <div className='width10'>
                設立
              </div>
              <div className=''>
                2022年2月1日
              </div>
            </div>
            <div className='flexRow margin1'>
              <div className='width10'>
                資本金
              </div>
              <div className=''>
                5,000,000円
              </div>
            </div>
            <div className='flexRow margin1'>
              <div className='width10'>
                事業内容
              </div>
              <div className=''>
                オンラインゲームの提供 等
              </div>
            </div>
            <div className='flexRow margin1'>
              <div className='width10'>
                顧問税理士
              </div>
              <div className=''>
                税理士法人　堀口会計
              </div>
            </div>
            <div className='flexRow margin1'>
              <div className='width10'>
                お問合せ先
              </div>
              <div className=''>
                contact@monatoka.com
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn alignItemsCenter width98vw padding1'>
        { headerRelative }
        <img className='cardImageAboutSP' src={imageEmilicaBT} alt='emilica' />
        <div className='height15 flexColumn justifyContentCenter alignItemsCenter'>
          <div className='font2 marginTopBottom1' >
            Knights of Monadomとは<br/>
          </div>
          <div className='marginTopBottom1' >
            ※愛称、モナダム
          </div>
        </div>
        <img className='cardImageAboutSP' src={imageSayokoBT} alt='sayoko' />
        <div className='cardImageAboutSP flexColumn justifyContentCenter alignItemsFlexStart '>
          <div className='font1p5 marginTopBottom1' >
            モナダム対応モナカードを集めてデッキを組もう。<br/>
            {/* モナトカポイントをチャージして準備完了。 */}
          </div>
          <button className='backgroundColorTransparent borderNone riseOut2 flexColumn justifyContentCenter alignItemsCenter marginBottom1'
            onClick={ () => {
              handleClickPurchaseItem(state, dispatch, navigate, { previousLocation: 'aboutknightsofmonadom' });
            }}
          >
            <div className='marginTopBottom1' >
              モナダム対応モナカード、モナトカポイントはこちらで購入できます。
            </div>
          </button>
        </div>
        <img className='cardImageAboutSP' src={imageHalcionBT} alt='halcion' />
        <div className='cardImageAboutSP flexColumn justifyContentCenter alignItemsCenter '>
          <div className='font1p5 marginTopBottom1' >
            対コンピュータ戦、対人戦を選んでデュエルを始めよう。
          </div>
        </div>
        <img className='cardImageAboutSP' src={imageNarumiyakunBT} alt='narumiyakun' />
        <div className='cardImageAboutSP flexColumn justifyContentCenter alignItemsCenter '>
          <div className='font1p5 marginTopBottom1' >
            遊び方はカンタン。<br/>
            ナイトカードを1枚選択して召喚すれば、<br/>
            ナイトのプロフィールやフィールドの状況に沿ってAIがバトルを展開！
          </div>
        </div>
        <img className='cardImageAboutSP' src={imageOmennoshoujoBT} alt='omennoshoujo' />
        <div className='cardImageAboutSP flexColumn justifyContentCenter alignItemsCenter '>
          <div className='font1p5 marginTopBottom1' >
            魔法を使えば戦略の幅も広がります。
          </div>
          <div className='marginTopBottom1' >
            <img className='width10' src={imageMagicRed} alt='magic red' />
          </div>
        </div>
        <img className='cardImageAboutSP' src={imageDensetsunoshoujoBT} alt='densetsunoshoujo' />
        <div className='cardImageAboutSP flexColumn justifyContentCenter alignItemsCenter '>
          <div className='font1p5 marginTopBottom1' >
            バトルの様子を見てみよう！
          </div>
          { duelHistoryExampleBlock }
          <button className='backgroundColorTransparent borderNone riseOut2 flexColumn justifyContentCenter alignItemsCenter marginBottom1'
            onClick={ () => {
              handleClickGetDuelHistoryAll(state, dispatch, 0, { action: 'duelHistoryAll' });
              dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAll'});
              handleClickDuelHistory(state, dispatch, navigate, { previousLocation: 'aboutknightsofmonadom' });
            }}
          >
            <div className='font1p5 marginTopBottom1' >
              ここからもっとたくさんのバトルが見れるよ。
            </div>
          </button>
        </div>
        <img className='cardImageAboutSP' src={imageAnkokunomaouLuciferBT} alt='ankokunomaouLucifer' />
        <div className='flexColumn justifyContentCenter alignItemsCenter '>
          <div className='font1p5 marginTopBottom1' >
            自分でモナダム対応カードをつくることもできます。<br/>
            {/* 発行、販売も自由！ */}
          </div>
          <button className='backgroundColorTransparent borderKOMFatBorder marginTopBottom1 riseOut2'
            onClick={ () => {
              if (creatorsCardExample !== undefined && Object.keys(state.registeredCard).length >= 1) {
                const body = {
                  card: {
                    asset: creatorsCardExample.asset, 
                  },
                  actionBox: 'close',
                };

                const popup = { type: 'itemDetailSP', body: body };
                dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
              }
            }}
          >
            <img className='width90vw' src={imageCardDetailHarukaMizugiVersion} alt='cardDetailHarukaMizugiVersion' />
          </button>
        </div>
        <img className='cardImageAboutSP' src={imageNzorichterBT} alt='nzorichter' />
        <div className='cardImageAboutSP flexColumn justifyContentCenter alignItemsCenter '>
          <div className='font1p5 marginTopBottom1' >
            バトルストーリーを楽しむのは、モナダムの大きな醍醐味のひとつ。<br/>
            面白いストーリーができたら、みんなにシェアしよう！<br/>
            <div className='flexRow justifyContentFlexStart alignItemsCenter '>
              <div className=''>
                (デュエル戦歴画面のシェアボタン
              </div>
                <img className='button1Dummy size2x2' src={iconShare} alt='share' />
              <div className=''>
                を押してね。)
              </div>
            </div>
          </div>
        </div>
        <img className='cardImageAboutSP' src={imageKurumichanBT} alt='kurumichan' />
        <div className='cardImageAboutSP flexColumn justifyContentCenter alignItemsCenter '>
          <div className='font1p5 marginTopBottom1' >
            {`現在発行、登録されているカードは${300}種類以上！`}
          </div>
          <div className='marginTopBottom1' >
            ※公式オリジナルカード、公式レプリカカード、一般クリエイターカードすべて含みます。
          </div>
          <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
            onClick={ () => handleClickCardList(state, dispatch, navigate, { previousLocation: 'aboutknightsofmonadom' }) }
          >
            { words.cardList[state.language] }
          </button>
        </div>
        <img className='cardImageAboutSP' src={imageToshinousanBT} alt='toshinousan' />
        <img className='cardImageAboutSP' src={imageMonatoka} alt='monatoka' />
        <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
          <div className='flexRow margin1'>
            <div className='width8'>
              会社名
            </div>
            <div className=''>
              株式会社モナトカ
            </div>
          </div>
          <div className='flexRow margin1'>
            <div className='width8'>
              代表取締役
            </div>
            <div className=''>
              渡邉潤平
            </div>
          </div>
          <div className='flexRow margin1'>
            <div className='width8'>
              所在地
            </div>
            <div className=''>
              〒101-0051 東京都千代田区神田神保町2-10-31 IWビル1F
            </div>
          </div>
          <div className='flexRow margin1'>
            <div className='width8'>
              設立
            </div>
            <div className=''>
              2022年2月1日
            </div>
          </div>
          <div className='flexRow margin1'>
            <div className='width8'>
              資本金
            </div>
            <div className=''>
              5,000,000円
            </div>
          </div>
          <div className='flexRow margin1'>
            <div className='width8'>
              事業内容
            </div>
            <div className=''>
              オンラインゲームの提供 等
            </div>
          </div>
          <div className='flexRow margin1'>
            <div className='width8'>
              顧問税理士
            </div>
            <div className=''>
              税理士法人　堀口会計
            </div>
          </div>
          <div className='flexRow margin1'>
            <div className='width8'>
              お問合せ先
            </div>
            <div className=''>
              contact@monatoka.com
            </div>
          </div>
        </div>
      </div>
      { headerFixed }
    </div>
  );
}

export {
  AboutKnightsOfMonadom,
}
